import axios from "axios";
import { useHistory } from "react-router-dom";
import { useToken } from "hooks/token.js";

export function useAxiosAuth () {
    let historyObj = useHistory();
    const [token, setToken] = useToken();

    axios.interceptors.request.use(function (config) {
        config.headers.Authorization = `Bearer ${token()}`
        return config;
      }, function (error) {
        return Promise.reject(error);
      });

    const sleep = async(ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
    }

    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if(error.response.status == 401){
                localStorage.removeItem('token')
                historyObj.push("/")
            }
            return Promise.reject(error);
        }
    );
}
/**
 * 
 * @param {String} url 
 * @returns {any}
 */
export async function getApiCall( url, {onError = null }) {
    const res = await axios({
    method: 'get',
    url: url,
    validateStatus: function(status) {
        return status < 205
    },
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*'
    },
    }).catch(function (error) {
      if(onError) {
        onError(error)
      }
    });
    if(res && res.hasOwnProperty('data') && res.data.hasOwnProperty('data')) {
        return res.data.data;
    } 
    return null;
   
}